import deleteCookie from '@/service/deleteCookie'
import getCookie from '@/service/getCookie'
import copyCookie from '@/service/copyCookie'


// 禁止複製+鎖右鍵+禁止全選  開發模式不啟用
function isCopyWhiteList() {
	let whiteList = /(ProductMenuPage|CoverageFormula|CoverageItemQuery|CoverageItemNameList)/;
	
	return location.href.search(whiteList) >= 0;
}

if (process.env.NODE_ENV !== 'development') {
	document.ondragstart = function() {return isCopyWhiteList()}
	document.oncontextmenu = function() {return isCopyWhiteList()}
	document.onselectstart = function() {return isCopyWhiteList()}
}

document.body.oncopy = function () {
	event.returnValue = isCopyWhiteList();
}

// 禁用 Enter 键 form 自動提交
document.onkeydown = function(event) {
var target, code, tag;
if (!event) {
    event = window.event; //針對 ie
    target = event.srcElement;
    code = event.keyCode;
    if (code == 13) {
    tag = target.tagName;
    if (tag == "TEXTAREA") {return true;} else {return false;}
    }
} else {
    target = event.target; //針對遵循 w3c 標準如 Firefox
    code = event.keyCode;
    if (code == 13) {
    tag = target.tagName;
    if (tag == "INPUT") {return false;} else {return true;}
    }
}
};

//  如果關閉視窗 清除掉 api-key cookie
if(process.env.NODE_ENV !== 'development'){
	window.onbeforeunload = function () {
	    let apiKeys_bak = decodeURI(getCookie('api-keys.bak'))
	    if (!apiKeys_bak){
		    let date = new Date();
		    date.setSeconds(date.getSeconds()+3);
		    
		    copyCookie('api-keys', 'api-keys.bak', date.toUTCString());
		    copyCookie('PD-ID', 'PD-ID.bak', date.toUTCString(), true, true);
		    
		    deleteCookie('api-keys')
		    document.cookie = "PD-ID=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.cathaylife.com.tw"	
	    }
	}; 
}
